export default {
"staffRiskInsight": () => import("/app/addons/hrm-addon-staff-change-risk/views/StaffChangeRiskOverview.vue"),
"retentionRiskInsight": () => import("/app/addons/hrm-addon-retention-risk-insight/views/RetentionRiskInsightOverview.vue"),
"contractProbationAlert": () => import("/app/addons/hrm-addon-contract-probation-alert/views/ContractProbationAlertOverview.vue")
}
